import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchCustomersTable(filter) {
    const body = {
        pageNumber: filter.pageNumber ?? 1,
        pageSize: filter.pageSize ?? 20,
        sortOptions: filter.sortOptions ?? null,
        searchOptions: filter.searchOptions ?? null,
    };

    const res = await apiFetch(`${API_URL}/api/Customer/GetCustomersTable`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`Failed to fetch customers: ${res.status}`);
    return res.json();
}

export async function fetchCustomersDropdown() {
    const res = await apiFetch(`${API_URL}/api/Customer/GetCustomersDropdown`, { method: 'GET' });
    if (!res.ok) throw new Error(`Failed to fetch customers: ${res.status}`);
    return res.json();
}

export async function createCustomer(body) {
    const res = await apiFetch(`${API_URL}/api/Customer/CreateCustomer`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create customer');
    return res.json();
}

export async function fetchCustomerById(id) {
    const res = await apiFetch(`${API_URL}/api/Customer/GetCustomerById/${id}`, { method: 'GET' });
    // Propagate 404 so the caller can render a "not found" panel — React
    // Query swallows the status code otherwise, so httpError attaches it.
    if (!res.ok) throw await httpError(res, 'Failed to fetch customer');
    return res.json();
}

export async function updateCustomer(id, body) {
    const res = await apiFetch(`${API_URL}/api/Customer/UpdateCustomer/${id}`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update customer');
    return res.json();
}

export async function deleteCustomer(id) {
    const res = await apiFetch(`${API_URL}/api/Customer/DeleteCustomer/${id}`, {
        method: 'POST',
    });
    if (!res.ok) throw await httpError(res, 'Failed to delete customer');
    // 200 OK with no body — nothing to deserialise.
}
